
































import { IConvertedSavedReply } from '@/api/types/response.types'
import Vue from 'vue'

export default Vue.extend({
  name: 'EditorSavedReplies',

  props: {
    savedReplies: {
      type: Array as () => IConvertedSavedReply[],
      default: Array as () => IConvertedSavedReply[],
    },

    message: {
      type: String,
      default: '',
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      selectedIndex: null,
      selectedReplyBody: '',
    }
  },

  watch: {
    message(value: string) {
      // remove HTML to compare only the content of the saved reply
      const valueWithoutHTML = value.replace(/<(?!\s*\/?\s*img)[^>]*>/gi, '')
      const selectedWithoutHTML = this.selectedReplyBody.replace(
        /<(?!\s*\/?\s*img)[^>]*>/gi,
        '',
      )

      if (valueWithoutHTML !== selectedWithoutHTML) {
        this.selectedReplyBody = ''
        this.selectedIndex = null
      }
    },
  },

  methods: {
    handleSelect(item: IConvertedSavedReply, index: number) {
      this.selectedIndex = index
      this.setSelectedReply(item.body)
      this.isOpen = false
    },

    /**
     * Emit event to Editor to apply the saved reply
     */
    setSelectedReply(savedReplyBody: string) {
      this.selectedReplyBody = savedReplyBody
      this.$emit('selected-saved-reply', savedReplyBody)
    },
  },
})
